export default "__VITE_ASSET__BXCEMUa2__"